<div>
    @if (indicadoresUi?.grupoNaoConfiguravel) {
    <app-alert-card type="info" title="Grupo preenchido pelo motor" icon="info">
        O CST/cClassTrib selecionado gera um grupo (transferência de crédito, ajuste de competência,
        estorno de crédito ou crédito presumido de IBS na Zona Franca de Manaus) cujos valores são
        preenchidos pelo motor fiscal na emissão, a partir do processo fiscal de origem da operação.
        Não há parâmetro a configurar aqui.
    </app-alert-card>
    }

    <app-ativacao-section-card
        [control]="ativacaoControl"
        titulo="IBS/CBS"
        descricaoAtivo="IBS/CBS ativo. As alíquotas, reduções e diferimentos abaixo serão aplicados no cálculo desta regra tributária."
        descricaoInativo="IBS/CBS inativo. Esta regra tributária não calcula IBS nem CBS."
        emptyStateDescricao="Ative o IBS/CBS acima para configurar as alíquotas de CBS, IBS UF e IBS Município.">
    </app-ativacao-section-card>

    @if (ativacaoControl.value) {
    <app-regra-tributaria-base-calculo-section [form]="ibsForm" [formulas]="formulasIbsCbs"></app-regra-tributaria-base-calculo-section>
    <app-regra-tributaria-ibs-uf-section [form]="ibsUfForm" [formulas]="formulasIbsUf" [cashbackHabilitado]="cashbackHabilitado" [cashbackTooltip]="cashbackTooltip"></app-regra-tributaria-ibs-uf-section>
    <app-regra-tributaria-ibs-municipio-section [form]="ibsMunicipioForm" [formulas]="formulasIbsMunicipio" [cashbackHabilitado]="cashbackHabilitado" [cashbackTooltip]="cashbackTooltip"></app-regra-tributaria-ibs-municipio-section>
    <app-regra-tributaria-cbs-section [form]="cbsForm" [formulas]="formulasCbs" [cashbackHabilitado]="cashbackHabilitado" [cashbackTooltip]="cashbackTooltip"></app-regra-tributaria-cbs-section>
    }
</div>
